import React from "react";
import { CtaButton } from "./CtaButton";
export function StickyOfferBar({
  visible
}: {
  visible: boolean;
}) {
  if (!visible) return null;
  return <aside className="sticky-offer" aria-label="Kit offer" data-id="element-237" data-mp="2u0k9gvs2qt8t">
      <div className="shell" data-id="element-238" data-mp="2p6pgf1qkx1x2">
        <p data-id="element-239" data-mp="2p5wjstlc3ssn">
          <strong data-id="element-240" data-mp="2p5mt13sgthlw">Customer Service Team Training</strong>
          <span data-id="element-241" data-mp="2k7laql2v5mbh">10 sessions + 5 bonuses · $27 USD</span>
        </p>
        <CtaButton href="#offer-details" size="sm" data-id="element-242" data-mp="2f9be061hqdnr">
          Get the kit
        </CtaButton>
      </div>
    </aside>;
}